// extracted by mini-css-extract-plugin
export default {"root":"Header_root__BoO8T","titleContainer":"Header_titleContainer__dD+pv","title":"Header_title__5XPSs","listingsResultLabel":"Header_listingsResultLabel__39tJt"};